<template>
    <div style="border: 1px #eeeeee solid;border-radius: 5px;display: flex;padding: 10px;margin-top: 20px;">
        <div style="width: 250px;">
            <img :src="courseImage" style="border-radius: 5px;width: 240px;height: 135px;" alt="">
        </div>
        <div style="padding-left: 10px;">
            <div style="margin-top: 10px;">{{ name }}<span
                style="border: 1px #00a4e0 solid;padding: 3px 6px;font-size: 12px;color: #00a4e0;border-radius: 3px;margin-left: 1em;">{{
                    type
                }}</span>
            </div>
            <div style="margin-top: 10px;color: #999999;">
                总学分：{{ score }} <span style="margin-left: 30px;">总学时</span>：{{ totalClass }} <span
                style="margin-left: 30px;">开课时间</span>：{{ startYmd }}
            </div>
            <div style="margin-top: 10px;color: #666666;">
                <span v-html="$options.filters.descLimit(desc)"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubCourseDetail',
    props: ['name', 'type', 'score', 'totalClass', 'startYmd', 'desc', 'courseImage'],
    created () {
        if (this.isEmpty(this.courseImage)) {
            this.courseImage = '@/assets/images/center/course.png'
        }
    },
    filters: {
        descLimit (value) {
            if (value.length === 0) {
                return '-'
            }
            let limit = 80
            if (value.length > limit) {
                value = value.substr(0, limit) + '...'
            }
            return value
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubCourseDetail.vue